/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiNotificationsQueryResponse, GetApiNotificationsQueryParams, GetApiNotifications400, GetApiNotifications401, GetApiNotifications403, GetApiNotifications500 } from "../../types/GetApiNotifications.ts";
import { getApiNotificationsQueryResponseSchema } from "../../zod/NotificationSchemas/getApiNotificationsSchema.ts";

function getGetApiNotificationsUrl() {
  const res = { method: 'GET', url: `/api/notifications` as const }  
  return res
}

/**
 * @summary Получение списка PUSH уведомлений с пагинацией
 * {@link /api/notifications}
 */
export async function getApiNotifications({ params }: { params?: GetApiNotificationsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiNotificationsQueryResponse, ResponseErrorConfig<GetApiNotifications400 | GetApiNotifications401 | GetApiNotifications403 | GetApiNotifications500>, unknown>({ method : "GET", url : getGetApiNotificationsUrl().url.toString(), params, ... requestConfig })  
  return getApiNotificationsQueryResponseSchema.parse(res.data)
}